import { render, staticRenderFns } from "./tecnico.vue?vue&type=template&id=5a00d562&scoped=true"
import script from "./tecnico.vue?vue&type=script&lang=js"
export * from "./tecnico.vue?vue&type=script&lang=js"
import style0 from "./tecnico.vue?vue&type=style&index=0&id=5a00d562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00d562",
  null
  
)

export default component.exports